import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
	name: 'moment'
})
export class MomentPipe implements PipeTransform {

	/**
	 * Transforme une date en string formatée
	 *
	 * @param dateInput - La date à formater (string)
	 * @param format - Le format de sortie (ex: 'DD-MM-YY HH:mm')
	 * @param timezone - Fuseau horaire optionnel :
	 *                   - undefined (défaut) : pas de conversion de timezone
	 *                   - 'paris' ou 'Europe/Paris' : convertit UTC → heure de Paris
	 *
	 * Par défaut, aucune conversion de timezone n'est appliquée (comportement original).
	 * Pour convertir une date UTC en heure de Paris, utiliser le paramètre 'paris'.
	 *
	 * Exemples :
	 *   {{date | moment: 'DD-MM-YY HH:mm'}}                    // Pas de conversion
	 *   {{date | moment: 'DD-MM-YY HH:mm': 'paris'}}           // Converti UTC → Paris
	 *   {{date | moment: 'DD-MM-YY HH:mm': 'Europe/Paris'}}    // Converti UTC → Paris
	 */
	transform(dateInput: string, format: string, timezone?: string) {
		if (!dateInput) {
			return '';
		}

		let date: moment.Moment;

		// Si conversion vers Paris demandée, interpréter comme UTC et convertir
		if (timezone === 'paris' || timezone === 'Europe/Paris') {
			date = moment.utc(dateInput);

			if (!date.isValid()) {
				date = moment.utc(dateInput, 'YYYY-MM-DD HH:mm:ss');
			}

			if (!date.isValid()) {
				console.error('Invalid date:', dateInput);
				return 'Invalid date';
			}

			// Convertir en heure de Paris (gestion auto été/hiver)
			date = date.tz('Europe/Paris');
		} else {
			// Comportement par défaut : pas de conversion (comme avant)
			date = moment(dateInput, 'YYYY-MM-DD HH:mm:ss');

			if (!date.isValid()) {
				console.error('Invalid date:', dateInput);
				return 'Invalid date';
			}
		}

		return date.format(format);
	}
	
}
